import { IDelegateController, IDelegateConstant } from 'ui-ng-delegate';

class CalendarTimeInputDelegate {
  constructor(DelegateController: IDelegateController, calendarTimeInputDelegateConstant: IDelegateConstant) {
    DelegateController(this, calendarTimeInputDelegateConstant);
  }
}

interface ICalendarTimeInputScope extends ng.IScope {
  setTime: (newVal: any, arg: any) => void;
  ngModel: any;
  hourBegin: number;
  hourEnd: number;
  validate: number;
  startBlank: any;
  onChanged: Function;
  timeOccurrence: any;
  timeProperty: string;
}

export class CalendarTimeInputController {
  ngModel?: any;
  timeOccurrence: any;
  timeProperty: string;
  hourBegin?: number;
  hourEnd?: number;
  validate?: number;
  startBlank?: any;
  onChanged?: Function;
  models: {
    hours: number;
    minutes: number;
    displayHours: number;
    displayMinutes: number | string;
    displayPeriod: string;
  };
  previousTime: any;
  lastValidTime: {
    hours: number;
    minutes: number;
  };
  isStartBlank: boolean;
  constructor(private $scope: ICalendarTimeInputScope) {
    this.models = {
      hours: 0,
      minutes: 0,
      displayHours: 0,
      displayMinutes: 0,
      displayPeriod: 'AM'
    };
    this.previousTime = {};
    this.lastValidTime = {
      hours: 0,
      minutes: 0
    };
    if (this.$scope.startBlank) {
      this.isStartBlank = true;
    }
    this.$scope.$watch('ngModel', (newVal: any, oldVal: any) => {
      if (!moment(newVal).isSame(this.previousTime)) {
        this.previousTime = newVal;
        this.$scope.setTime(newVal, this);
      }
    });
  }
  updatedModel(): void {
    if (_.isUndefined(this.$scope.ngModel)) {
      return;
    }

    this.displayHours();
    this.displayMinutes();
    this.displayPeriod();
  }

  changedModel(): void {
    if (this.isValidTime() && _.isFunction(this.$scope.onChanged)) {
      this.saveValidTime();
      this.$scope.onChanged({ timeParams: this.getTimeChangeParams() });
    } else {
      this.revertTime();
    }
    this.updatedModel();
  }

  isValidTime(): boolean {
    if (_.isBoolean(this.$scope.validate) && this.$scope.validate === false) {
      return true;
    }
    const isValidRange: boolean =
      this.models.hours >= this.$scope.hourBegin && this.models.hours <= this.$scope.hourEnd;
    const checkIfValidTimePair = (): boolean => {
      let isValidTimePair = false;
      const toSimpleMilitaryTime = (timeString: string): number => {
        let militaryTimeNumber = timeString.slice(0, -2);
        militaryTimeNumber = militaryTimeNumber.replace(/\:/g, '');
        return parseInt(militaryTimeNumber, 10);
      };

      if (!_.isEmpty(this.$scope.timeOccurrence)) {
        let timeOccurrenceToTime = toSimpleMilitaryTime(this.$scope.timeOccurrence.toInput);
        let comparisonTimeModel = this.models.hours * 100 + this.models.minutes;
        if (this.$scope.timeProperty === 'from_tm') {
          isValidTimePair = comparisonTimeModel < timeOccurrenceToTime;
        } else {
          isValidTimePair = comparisonTimeModel > timeOccurrenceToTime;
        }
      }
      return isValidTimePair;
    };
    const isValidTimePair: boolean = checkIfValidTimePair();

    return isValidRange;
  }

  saveValidTime = (): void => {
    this.lastValidTime.hours = this.models.hours;
    this.lastValidTime.minutes = this.models.minutes;
  };

  revertTime = (): void => {
    this.models.hours = this.lastValidTime.hours;
    this.models.minutes = this.lastValidTime.minutes;
  };

  getTimeChangeParams = (): Object => {
    const getTimeUnitString = (timeUnit: number) => (timeUnit > 9 ? timeUnit.toString() : `0${timeUnit.toString()}`);
    let updatedTimeString = `${getTimeUnitString(this.models.hours)}:${getTimeUnitString(this.models.minutes)}`;

    return {
      originalTime: this.$scope.timeOccurrence,
      updatedTimeString: updatedTimeString,
      timeProperty: this.$scope.timeProperty
    };
  };

  switchPeriod(): void {
    this.models.hours = this.models.hours >= 12 ? this.models.hours - 12 : this.models.hours + 12;

    this.changedModel();
  }

  displayHours(): number {
    let hoursToDisplay = this.models.hours;

    if (this.models.hours > 12) {
      hoursToDisplay = this.models.hours - 12;
    }

    if (hoursToDisplay === 0) {
      hoursToDisplay = 12;
    }

    this.models.displayHours = hoursToDisplay;
    return hoursToDisplay;
  }

  displayMinutes() {
    this.models.displayMinutes = this.models.minutes > 9 ? this.models.minutes : `0${this.models.minutes}`;
    return this.models.displayMinutes;
  }

  displayPeriod(): string {
    this.models.displayPeriod = this.models.hours >= 12 ? 'PM' : 'AM';
    return this.models.displayPeriod;
  }

  onChangeHours(HH: string): void {
    const hours = parseInt(HH, 10);

    if (_.isNumber(hours) && !_.isNaN(hours) && hours < 25) {
      this.models.hours = hours % 12;

      if (this.models.displayPeriod === 'PM') {
        this.models.hours += 12;
      }
    }

    this.changedModel();
  }

  onChangeMinutes(MM: string): void {
    const minutes = parseInt(MM, 10);

    if (_.isNumber(minutes) && !_.isNaN(minutes) && minutes < 61) {
      this.models.minutes = minutes % 60;
    }

    this.changedModel();
  }

  onChangePeriod(period: string): void {
    if (!period) {
      period = this.displayPeriod();
    }

    period = period.toUpperCase();

    if (!(period === 'AM' || period === 'PM')) {
      period = this.displayPeriod();
    }

    if (period === 'AM' && this.models.hours >= 12) {
      this.models.hours -= 12;
    } else if (period === 'PM' && this.models.hours < 12) {
      this.models.hours += 12;
    }

    this.changedModel();
  }

  onFocus() {
    this.isStartBlank = false;
  }
}

angular
  .module('ui-ng-calendar')
  .controller('calendarTimeInputController', CalendarTimeInputController)
  .constant('calendarTimeInputDelegateConstant', {
    uniqueComponent: 'calendar-time-input',
    vocabulary: {
      setTime: function setTime_calendarTimeInput(
        scope: any,
        element: any,
        attrs: ng.IAttributes,
        event: ng.IAngularEvent,
        time: any,
        context: any
      ) {
        const newTime = moment(time);
        context.models.hours = newTime.hour();
        context.models.minutes = newTime.minutes();
        context.saveValidTime();
        context.updatedModel();
      }
    }
  })
  .directive(
    'calendarTimeInput',
    function calendarTimeInput(DelegateResponder: any, calendarTimeInputDelegateConstant: any) {
      return {
        restrict: 'E',
        replace: false,
        require: '?ngModel',
        templateUrl: 'ui-ng-calendar/src/directives/calendar_time_input/calendar_time_input.html',
        controller: 'calendarTimeInputController',
        controllerAs: '$ctrl',
        scope: {
          ngModel: '=?',
          timeOccurrence: '=',
          timeProperty: '@',
          hourBegin: '=?',
          hourEnd: '=?',
          validate: '=?',
          startBlank: '=?',
          onChanged: '&?'
        },
        compile: function calendarTimeInputCompile(element: ng.IRootElementService, attrs: ng.IAttributes) {
          return DelegateResponder(
            calendarTimeInputDelegateConstant,
            function (scope: ng.IScope, element: ng.IRootElementService, attrs: ng.IAttributes) {}
          );
        }
      };
    }
  )
  .service('calendarTimeInputDelegate', CalendarTimeInputDelegate);



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/directives/calendar_time_input/calendar_time_input.ts